import Parse from "parse";

Parse.initialize("heinzerling");
Parse.serverURL = "https://heinzerling-parse-server.openinc.dev/parse";
